module.exports = __webpack_public_path__ + "img/request-ok.1e8f4a9c.svg";